import { render, staticRenderFns } from "./aventraNetwork.vue?vue&type=template&id=74937d6d&"
import script from "./aventraNetwork.vue?vue&type=script&lang=js&"
export * from "./aventraNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports